import { alpha, type SxProps, type Theme } from '@mui/material';
import { webFonts } from './theme/webTheme';

// Shared look for every data table in the platform: uppercase hairline headers, generous
// row height, zebra striping + a clear hover so a single row is easy to track
// across a wide, full-width table.
export const dataTableSx: SxProps<Theme> = {
  '& .MuiTableCell-head': {
    fontSize: 11.5,
    fontWeight: 700,
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
    color: 'text.secondary',
    backgroundColor: 'background.default',
    borderBottom: '2px solid',
    borderColor: 'divider',
    py: 1.25,
  },
  '& .MuiTableBody-root .MuiTableCell-root': {
    borderColor: 'divider',
    py: 1.5,
    fontSize: 14,
  },
  '& .MuiTableBody-root .MuiTableRow-root': {
    transition: 'background-color 120ms ease',
  },
  '& .MuiTableBody-root .MuiTableRow-root:nth-of-type(even)': {
    backgroundColor: (theme) => alpha(theme.palette.text.primary, 0.025),
  },
  '& .MuiTableBody-root .MuiTableRow-root:hover': {
    backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.08),
  },
};

// The primary (title) cell: heavier weight + primary ink so the "who is who"
// reads at a glance against the muted secondary columns.
export const titleCellSx = {
  fontWeight: 600,
  color: 'text.primary',
};

// For opaque identifier columns (actor/target IDs, slugs): monospace + muted so
// they read as codes, not prose.
export const monoCellSx = {
  fontFamily: webFonts.mono,
  fontSize: 13,
  color: 'text.secondary',
};
